import moment from "moment-timezone";

/**
 * Format a date for the UI
 * @param date - The date to format
 * @returns The formatted date or null if the date is invalid
 */
export function formatDateForUI(date: string): string | null {
    const momentDate = moment(date);
    if (!momentDate.isValid()) {
        console.error("Invalid date", date);
        return null;
    }
    return momentDate.format("DD/MM/YYYY");
}

/**
 * Indicates if a date is today
 * @param date - The date to check
 * @returns True if the date is today, false otherwise
 */
export function isDateOfToday(date): boolean {
    const momentDate = moment(date);
    if (!momentDate.isValid()) {
        console.error("Invalid date", date);
        return false;
    }
    return momentDate.isSame(moment(), "day");
}
